import React, { Component } from 'react';
import { connect } from 'react-redux';

class QuickLinkDisplay extends Component {
  render() {
    const { selectedQuickLink } = this.props;

    return (
      <div className="activity-summary-container__quick-link-display">
        <a href={selectedQuickLink} target="_blank">
          {selectedQuickLink}
        </a>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selectedQuickLink: state.dashboardReducer.selectedQuickLink,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(QuickLinkDisplay);



// WEBPACK FOOTER //
// ./src/app/main/dashboard/components/quick-link-display.js